import React, { createContext, useContext } from 'react';

const LocationContext = createContext();

export const LocationProvider = ({ children, userLocation }) => {
  return (
    <LocationContext.Provider value={userLocation}>
      {children}
    </LocationContext.Provider>
  );
};

export const useUserLocation = () => {
  return useContext(LocationContext);
};